import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from '@dal/core';
import { enableProdMode } from '@angular/core';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    console.log('✅ App bootstrapped successfully');
    // Note: Upload functionality is now handled by AsyncUploadClient in UploadWorkerService
    // The service uses Web Workers instead of Service Workers for better performance
  })
  .catch((err) => console.error(err));

